import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const selectCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

export default function TicketFilters({ filters = {}, setFilters }) {
  const [opts, setOpts] = useState({ categories: [], queues: [], assignees: [], depts: [] });
  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  useEffect(() => {
    const token = localStorage.getItem("token");
    Promise.all([
      fetch(`${API}/api/admin/tickets/categories`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/admin/tickets/queues`,     { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).catch(() => []),
    ]).then(([cats, queues]) => {
      setOpts({
        categories: Array.isArray(cats)   ? cats.map(c => c.key || c)   : [],
        queues:     Array.isArray(queues) ? queues.map(q => q.name || q) : [],
        depts:      ["Engineering","Product","QA","HR","Ops","Finance"],
        assignees:  Array.isArray(queues) ? queues.map(q => q.name || q) : [],
      });
    });
  }, []);

  const { query = "", category = "ALL", priority = "ALL", status = "ALL", dept = "ALL", assignee = "ALL" } = filters;

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-7 gap-3">
        <div className="md:col-span-2">
          <label className={labelCls}>Search</label>
          <div className="flex items-center gap-2">
            <Search size={13} className="text-[#00ff90]/40 shrink-0" />
            <input value={query} onChange={e => set("query", e.target.value)}
              className="flex-1 bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50"
              placeholder="ID, subject, requester…" />
          </div>
        </div>

        {[
          { key: "category", label: "Category",  opts: ["ALL", ...opts.categories,  "IT","Payroll","Leave","Facilities"] },
          { key: "priority", label: "Priority",  opts: ["ALL","P1","P2","P3","P4"] },
          { key: "status",   label: "Status",    opts: ["ALL","Open","Pending","In Progress","Escalated","Closed"] },
          { key: "dept",     label: "Department",opts: ["ALL", ...opts.depts] },
          { key: "assignee", label: "Assignee",  opts: ["ALL", ...opts.assignees, "HR Payroll","HR Ops","IT Help","IT L2"] },
        ].map(({ key, label, opts: o }) => (
          <div key={key}>
            <label className={labelCls}>{label}</label>
            <select className={selectCls} value={filters[key] || "ALL"} onChange={e => set(key, e.target.value)}>
              {[...new Set(o)].map(x => <option key={x} value={x}>{x === "ALL" ? `All ${label}s` : x}</option>)}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}